import {navSchema} from './navSchema';

export const initialState = {
  init: false,
  isEditMode: false,
  reviewsSortBy: 'recent',
  nav: [...navSchema],
  isPhotosSortable: false,
  firm: {},
  tabs: {
    reviews: {
      isActive: false,
      data: {
        rows: [],
        page: 0,
        rowsCount: 0,
        pagesCount: 0,
        perPage: 0,
        firmsCount: 0,
      },
    },
    portfolio: {
      isActive: false,
      data: {
        current: {
          page: 0,
          pagesCount: 0,
          perPage: 0,
          rows: [],
          rowsCount: 0,
        },
        realized: {
          page: 0,
          pagesCount: 0,
          perPage: 0,
          rows: [],
          rowsCount: 0,
        },
      },
    },
    about: {
      isActive: false,
      data: {
        descriptionBlock: null,
        descriptionSubBlocks: [],
        awardsBlock: null,
        photosBlock: [],
      },
    },
    strategy: {
      isActive: false,
      data: {
        funds: [],
        investment: null,
      },
    },
  },
  permissions: {
    AllowedChangeDealMark: true,
    AllowedEditMod: false,
  },
  relativeFirms: [],
  windowWidth: window.innerWidth + 'px',
};
